"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _atomize = _interopRequireDefault(require("@quarkly/atomize"));

var _components = require("@quarkly/components");

var _widgets = require("@quarkly/widgets");

var _md = require("react-icons/md");

var _reactRouterDom = require("react-router-dom");

var _router = require("@reach/router");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var overrides = {
  List: {
    kind: 'Ul'
  },
  Item: {
    kind: 'Li'
  },
  'Sub Head': {
    kind: 'Box'
  },
  'Sub Head Text': {
    kind: 'Text'
  },
  'Sub Head Icon': {
    kind: 'Icon'
  },
  'Sub Head Icon :open': {
    props: {
      transform: 'rotate(0deg)'
    }
  },
  'Sub Head Icon :closed': {
    props: {
      transform: 'rotate(-90deg)'
    }
  },
  'Sub Body': {
    kind: 'Box'
  },
  'Sub Body :open': {
    props: {
      display: 'block'
    }
  },
  'Sub Body :closed': {
    props: {
      display: 'none'
    }
  },
  Link: {
    kind: 'Link',
    props: {
      color: '--primary'
    }
  },
  'Link :active': {
    props: {
      color: '--secondary'
    }
  }
};

var getAPI = function getAPI() {
  if (typeof window !== 'undefined') {
    return window.QAPI || {};
  }

  if (typeof global !== 'undefined') {
    return global.QAPI || {};
  }

  return {};
};

var getParent = function getParent(pages, pageId) {
  if (!pageId || !pages[pageId]) return null;
  return Object.values(pages).find(function (_ref) {
    var _ref$children = _ref.children,
        children = _ref$children === void 0 ? [] : _ref$children;
    return children && Array.isArray(children) && children.includes(pageId);
  });
};

var Ul = _atomize["default"].ul();

var Li = _atomize["default"].li();

var Sub = function Sub(_ref2) {
  var common = _ref2.common,
      item = _ref2.item,
      other = _ref2.other;
  var tabState = common.tabState,
      override = common.override;
  var id = item.id,
      name = item.name,
      pageUrl = item.pageUrl;
  var pagePath = other.pagePath,
      href = other.href,
      match = other.match,
      expanded = other.expanded;
  var isClickable = tabState !== 'keepExpanded';
  var isSubOpenForce = tabState === 'keepExpanded' || tabState === 'expandAll';
  var isSubCloseForce = tabState === 'collapseAll';

  var _useState = (0, _react.useState)(expanded && !isSubCloseForce || isSubOpenForce),
      _useState2 = _slicedToArray(_useState, 2),
      isSubOpen = _useState2[0],
      setSubOpen = _useState2[1];

  var onSubToggle = (0, _react.useCallback)(function () {
    setSubOpen(!isSubOpen);
  }, [isSubOpen]);
  var subOpenStatus = isSubOpen ? ':open' : ':closed';
  (0, _react.useEffect)(function () {
    var subOpenForce = tabState === 'keepExpanded' || tabState === 'expandAll';
    var subCloseForce = tabState === 'collapseAll';
    setSubOpen(expanded && !subCloseForce || subOpenForce);
  }, [tabState, expanded]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({
    padding: "6px 12px",
    "align-items": "center",
    display: "flex",
    cursor: isClickable ? 'pointer' : 'default',
    onClick: isClickable && onSubToggle
  }, override('Sub Head', "Sub Head-".concat(pageUrl), match && 'Sub Head :active', "Sub Head ".concat(subOpenStatus))), /*#__PURE__*/_react["default"].createElement(_widgets.Text, _extends({
    margin: "0",
    "white-space": "nowrap"
  }, override('Sub Head Text', match && 'Sub Head Text :active', "Sub Head Text ".concat(subOpenStatus), "Sub Head Text-".concat(pageUrl))), override("Sub Head Text-".concat(pageUrl)).children || 'Group Name'), isClickable && /*#__PURE__*/_react["default"].createElement(_widgets.Icon, _extends({
    category: "md",
    defaultIcon: _md.MdKeyboardArrowDown,
    size: "16px"
  }, override('Sub Head Icon', "Sub Head Icon-".concat(pageUrl), match && 'Sub Head Icon :active', "Sub Head Icon ".concat(subOpenStatus))))), /*#__PURE__*/_react["default"].createElement(_widgets.Box, _extends({
    padding: "6px 12px"
  }, override('Sub Body', "Sub Body-".concat(pageUrl), match && 'Sub Body :active', "Sub Body ".concat(subOpenStatus))), /*#__PURE__*/_react["default"].createElement(_widgets.Link, _extends({
    padding: "6px 12px",
    "white-space": "nowrap",
    display: "block",
    href: href
  }, override('Link', "Link-".concat(pageUrl), match && 'Link :active', "Link ".concat(subOpenStatus))), override("Link-".concat(pageUrl)).children || name), /*#__PURE__*/_react["default"].createElement(List, _extends({
    "list-style": "none",
    rootId: id,
    path: pagePath
  }, common, override('List', "List-".concat(pageUrl), match && 'List :active', "List ".concat(subOpenStatus))))));
};

var Item = function Item(_ref3) {
  var path = _ref3.path,
      common = _ref3.common,
      item = _ref3.item;

  var _getAPI = getAPI(),
      mode = _getAPI.mode,
      projectType = _getAPI.projectType;

  var depth = common.depth,
      level = common.level,
      tabState = common.tabState,
      override = common.override;
  var name = item.name,
      pageUrl = item.pageUrl,
      children = item.children;
  var hasSub = !!(children && children.length && level < depth);
  var expand = tabState === 'expandActive';
  var pagePath = [].concat(_toConsumableArray(path), [mode === 'production' && pageUrl === 'index' ? '' : pageUrl]);
  var href = pagePath[0] === '/' ? "".concat(pagePath.join('/')) : "/".concat(pagePath.join('/'));
  var match = null;
  var expanded = false; // TODO: needs to be resolved, hook inside conditional statement

  if (projectType === 'gatsby') {
    match = (0, _router.useMatch)(href) && true; // eslint-disable-line
  } else {
    match = (0, _reactRouterDom.useRouteMatch)({
      path: href,
      exact: true
    }) && true; // eslint-disable-line

    expanded = (0, _reactRouterDom.useRouteMatch)({
      path: href,
      exact: !expand
    }) && true; // eslint-disable-line
  }

  return /*#__PURE__*/_react["default"].createElement(Li, override('Item', "Item-".concat(pageUrl), match && 'Item :active'), hasSub ? /*#__PURE__*/_react["default"].createElement(Sub, _extends({
    path: path,
    common: common,
    item: item,
    other: {
      projectType: projectType,
      pagePath: pagePath,
      href: href,
      match: match,
      expanded: expanded
    }
  }, override('Sub', "Sub-".concat(pageUrl), match && 'Sub :active'))) : /*#__PURE__*/_react["default"].createElement(_widgets.Link, _extends({
    padding: "6px 12px",
    "white-space": "nowrap",
    display: "block",
    href: href
  }, override('Link', "Link-".concat(pageUrl), match && 'Link :active')), override("Link-".concat(pageUrl)).children || name));
};

var List = function List(_ref4) {
  var _rootPage$children$ma, _rootPage$children;

  var rootId = _ref4.rootId,
      path = _ref4.path,
      pages = _ref4.pages,
      depth = _ref4.depth,
      expand = _ref4.expand,
      _ref4$level = _ref4.level,
      level = _ref4$level === void 0 ? 0 : _ref4$level,
      tabState = _ref4.tabState,
      override = _ref4.override,
      rest = _objectWithoutProperties(_ref4, ["rootId", "path", "pages", "depth", "expand", "level", "tabState", "override"]);

  var rootPage = pages === null || pages === void 0 ? void 0 : pages[rootId];
  var common = {
    pages: pages,
    depth: depth,
    expand: expand,
    level: level + 1,
    tabState: tabState,
    override: override
  };
  var list = (_rootPage$children$ma = rootPage === null || rootPage === void 0 ? void 0 : (_rootPage$children = rootPage.children) === null || _rootPage$children === void 0 ? void 0 : _rootPage$children.map(function (id) {
    return pages[id];
  })) !== null && _rootPage$children$ma !== void 0 ? _rootPage$children$ma : [];
  return /*#__PURE__*/_react["default"].createElement(Ul, _extends({
    padding: "0",
    "list-style": "none"
  }, rest), list.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(Item, {
      key: item.id,
      path: path,
      common: common,
      item: item
    });
  }));
};

var MenuWithGroups = function MenuWithGroups(_ref5) {
  var depth = _ref5.depth,
      rootId = _ref5.rootId,
      expand = _ref5.expand,
      tabState = _ref5.tabState,
      props = _objectWithoutProperties(_ref5, ["depth", "rootId", "expand", "tabState"]);

  var _useOverrides = (0, _components.useOverrides)(props, overrides, defaultProps),
      override = _useOverrides.override,
      rest = _useOverrides.rest;

  var pages = getAPI().pages || {};
  var path = [];

  if (rootId !== 'root') {
    var parent = pages[rootId];

    while (parent && parent.id !== 'root') {
      var _parent;

      path = [parent.pageUrl].concat(_toConsumableArray(path));
      parent = getParent(pages, (_parent = parent) === null || _parent === void 0 ? void 0 : _parent.id);
    }
  }

  return /*#__PURE__*/_react["default"].createElement(List, _extends({
    "user-select": "none",
    "flex-direction": "column",
    display: "flex",
    position: "relative",
    "z-index": "10",
    rootId: rootId,
    path: path,
    pages: pages,
    depth: depth,
    expand: expand,
    tabState: tabState,
    override: override
  }, rest));
};

var pagesList = Object.values(getAPI().pages || {}).map(function (_ref6) {
  var pageUrl = _ref6.pageUrl,
      id = _ref6.id;
  return {
    title: pageUrl,
    value: id
  };
});
var propInfo = {
  depth: {
    title: {
      en: 'Maximum nesting',
      ru: 'Максимальная вложенность'
    },
    control: 'input',
    type: 'number',
    category: 'Main',
    weight: 1
  },
  rootId: {
    title: {
      en: 'Root page ID',
      ru: 'ID корневой страницы'
    },
    control: 'select',
    variants: pagesList,
    category: 'Main',
    weight: 1
  },
  tabState: {
    title: {
      en: 'Condition of groups by default',
      ru: 'Состояние групп по умолчанию'
    },
    control: 'select',
    variants: [{
      title: {
        en: 'Collapse all groups',
        ru: 'Свернуть все группы'
      },
      value: 'collapseAll'
    }, {
      title: {
        en: 'Expand before the active menu item',
        ru: 'Раскрыть перед активным пунктом'
      },
      value: 'expandActive'
    }, {
      title: {
        en: 'Expand all groups',
        ru: 'Раскрыть все группы'
      },
      value: 'expandAll'
    }, {
      title: {
        en: 'Keep all tabs open',
        ru: 'Держать все вкладки раскрытыми'
      },
      value: 'keepExpanded'
    }],
    weight: 1
  }
};
var defaultProps = {
  rootId: 'root',
  depth: 10,
  tabState: 'expandActive'
};
Object.assign(MenuWithGroups, {
  title: 'Menu with groups',
  description: {
    en: 'Multi-level menu, in which subpages are combined into a named group',
    ru: 'Многоуровневое меню, в котором вложенные страницы объединяются в именованную группу'
  },
  propInfo: propInfo,
  defaultProps: defaultProps,
  overrides: overrides
});
var _default = MenuWithGroups;
exports["default"] = _default;